import { connect } from "react-redux";
import ManagePm from "./managePM";
import { bindActionCreators } from "redux";
import {fetchPmAssignee,postSchedulePM} from "services/redux/maintenance/pmTicket/action";
const mapStateToProps = (state) => ({
  pmAssigneeList: state.pmTicketReducer.pmAssigneeList,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchPmAssignee,
      postSchedulePM,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ManagePm);
